import { render } from "./changeMain.vue?vue&type=template&id=0c5deaec&scoped=true"
import script from "./changeMain.vue?vue&type=script&lang=js"
export * from "./changeMain.vue?vue&type=script&lang=js"

import "./changeMain.vue?vue&type=style&index=0&id=0c5deaec&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5deaec"]])

export default __exports__